/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { createEpicMiddleware } from 'redux-observable';

import { store as sarsaparillaStore, sarsaparillaReducers } from 'sarsaparilla';
import { authReducers } from 'shared-ui/auth/redux';

import { externalRatingReviewsReducers } from 'ui-rating-review';
import parkPassReducers from 'ui-sitepass/src/reducers';

import { timedEntryReducers as timedEntry } from '../src/reducers/timedEntryReducers';
import { rootEpic } from '../src/epics';

const initialState = {
    ...sarsaparillaStore(),
};

const rootReducer = combineReducers({
    timedEntry,
    ratingReviews: externalRatingReviewsReducers,
    parkpass: parkPassReducers,
    ...sarsaparillaReducers,

    // Auth - MUST COME AFTER SARSA REDUCERS DURING AUTH MIGRATION
    ...authReducers,
});

export function setupStore(preloadedState?: any) {
    const epicMiddleware = createEpicMiddleware();

    const store = configureStore({
        preloadedState,
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => {
            return getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: ['launchdarkly/setClient'],
                    ignoredPaths: ['launchdarkly'],
                },
                immutableCheck: {
                    ignoredPaths: ['timedEntry'],
                },
            }).concat(epicMiddleware);
        },
        devTools: process.env.DEV_TOOLS_ENABLED,
    });

    epicMiddleware.run(rootEpic);

    return store;
}

const store = setupStore(initialState);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;

export default store;

// cSpell:ignore parkpass
